import { useState } from "react";

export interface BulkResultState {
  successCount: number;
  failedNumbers: string[];
  failedDetails?: { phoneNumber: string; reason: string | null }[];
}

interface BulkSuccessPayload {
  successCount: number;
  failedCount: number;
  failedNumbers: string[];
  failedDetails?: { phoneNumber: string; reason: string | null }[];
}

// Owns the outcome of a bulk send or bulk schedule
export function useBulkResult() {
  const [result, setResult] = useState<BulkResultState | null>(null);
  const [blockError, setBlockError] = useState<string | null>(null);
  
  const handleSuccess = (payload: BulkSuccessPayload): boolean => {
    if (payload.failedCount > 0) {
      setResult({
        successCount: payload.successCount,
        failedNumbers: payload.failedNumbers ?? [],
        failedDetails: payload.failedDetails ?? [],
      });
      
      return true;
    }
    
    return false;
  };
  
  const handleFailure = (message: string) => {
    setBlockError(message);
  };
  
  const reset = () => {
    setResult(null);
    setBlockError(null);
  };
  
  // A partial result opens the results view a thrown error becomes an inline block message
  return { result, blockError, handleSuccess, handleFailure, reset, setBlockError };
}
